import { getStores } from '@services/storesServices';
import { useQuery } from '@tanstack/react-query';

export const useGetStores = (enabled: boolean = true) => {
  return useQuery({
    queryKey: ['stores'],
    queryFn: getStores,
    enabled,
  });
};
